(() => {
  "use strict";

  const resetCarousel = (section) => {
    const carousel = section.querySelector(".peguu-how__cards");
    if (!carousel) return;

    carousel.scrollLeft = 0;
  };

  const resetAll = (root = document) => {
    if (root.matches?.(".peguu-how")) resetCarousel(root);
    root.querySelectorAll?.(".peguu-how").forEach(resetCarousel);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => resetAll());
  } else {
    resetAll();
  }

  window.addEventListener("pageshow", () => resetAll());

  document.addEventListener("shopify:section:load", (event) => {
    resetAll(event.target);
  });
})();
